/**
 * Session-scoped commercial/expansion AG Grid filter + sort state.
 * Survives navigating away from the main board tables within the same tab.
 */

const STORAGE_KEY = "pb_board_grid_view_state_v1";

function readAll() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(next) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
}

/** @param {"commercial"|"expansion"} panel */
export function loadBoardGridViewState(panel) {
  const all = readAll();
  const entry = all[panel];
  return entry && typeof entry === "object" ? entry : null;
}

/** @param {"commercial"|"expansion"} panel */
export function patchBoardGridViewState(panel, patch) {
  const all = readAll();
  const prev = all[panel] && typeof all[panel] === "object" ? all[panel] : {};
  all[panel] = { ...prev, ...patch };
  writeAll(all);
  return all[panel];
}

/** @param {"commercial"|"expansion"} panel */
export function clearBoardGridFilterState(panel) {
  const all = readAll();
  const prev = all[panel] && typeof all[panel] === "object" ? all[panel] : {};
  const { filterModel: _fm, filtersInitialized: _fi, ...rest } = prev;
  if (Object.keys(rest).length) all[panel] = rest;
  else delete all[panel];
  writeAll(all);
}

/** @param {"commercial"|"expansion"} panel */
export function clearBoardGridViewState(panel) {
  const all = readAll();
  delete all[panel];
  writeAll(all);
}

export function clearAllBoardGridViewState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
